module.exports = __webpack_public_path__ + "static/media/cognito-stripe-wix.2dae0d21.png";